import { render, staticRenderFns } from "./Macchinari.vue?vue&type=template&id=1e2b178f&scoped=true"
import script from "./Macchinari.vue?vue&type=script&lang=js"
export * from "./Macchinari.vue?vue&type=script&lang=js"
import style0 from "./Macchinari.vue?vue&type=style&index=0&id=1e2b178f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b178f",
  null
  
)

export default component.exports